// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"layout_mainContainer__JLVrP","body":"layout_body__AOMdy","html":"layout_html__cztFt"};